// extracted by mini-css-extract-plugin
module.exports = {"freemium-banner-responsive":"_3hLVS","freemiumBannerResponsive":"_3hLVS","rtl":"_2Y_J5","ltr":"_2_v7X","overlay":"_5V2-v","link":"qM9Gx","text":"_2yqNC","logo":"zGeWA"};